import React from "react"
import { Heading } from "../common/Heading"
// import { services } from "../data/dummydata"
import c from "./Images/services/c++.png";
import css from "./Images/services/css.png";
import git from "./Images/services/git.png";
import html from "./Images/services/html.png";
import java from "./Images/services/java.png";
import js from "./Images/services/js.png";
import node from "./Images/services/node.png";
import react from "./Images/services/react.png";

export const Services = () => {
  return (
    <>
      <section className='services'>
        <div className='container'>
          <Heading title='Services' />
          <div className='content grid3'>
            {/* {services.map((item) => ( */}
              <div className='box' data-aos='flip-left'>
                <img src={html} alt='' className='sImage'/>
                <h3>HTML</h3>
              </div>
              <div className='box' data-aos='flip-left'>
                <img src={css} alt='' className='sImage'/>
                <h3>CSS</h3>
              </div>
              <div className='box' data-aos='flip-left'>
                <img src={js} alt='' className='sImage'/>
                <h3>JAVA SCRIPT</h3>
              </div>
              <div className='box' data-aos='flip-left'>
                <img src={java} alt='' className='sImage'/>
                <h3>JAVA</h3>
              </div>
              <div className='box' data-aos='flip-left'>
                <img src={react} alt='' className='sImage'/>
                <h3>REACT</h3>
              </div>
              <div className='box' data-aos='flip-left'>
                <img src={node} alt='' className='sImage'/>
                <h3>NODE JS</h3>
              </div>
              <div className='box' data-aos='flip-left'>
                <img src={c} alt='' className='sImage'/>
                <h3>C++</h3>
              </div>
              <div className='box' data-aos='flip-left'>
                <img src={git} alt='' className='sImage'/>
                <h3>GITHUB</h3>
              </div>
            {/* ))} */}
          </div>
        </div>
      </section>
    </>
  )
}
